<label class="cursor-pointer">
  <p-checkbox
    [label]="'data-source.common.visibility.public' | translate"
    [trueValue]="visibilityEnum.PUBLIC"
    [falseValue]="visibilityEnum.PRIVATE"
    [binary]="true"
    [formControl]="formControl"
  ></p-checkbox>
  {{ 'data-source.common.visibility.description' | translate }}
</label>
